<template>
  <div></div>
</template>

<script>
export default {
  name: "PageTeams",
};
</script>

<style lang="sass" scoped></style>
